import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card';
import { formatNumber } from '../../../Base/Services/TemplatesServices';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

import { ResumenVentasAnualesTabla, ResumenVentasAnualesTotales, ResumenVentasAnualesTotalesGrafico } from '../../../API/Ventas/ResumenVentasRequest';
import { colorCotton, colorSintetico, datalabelsGerencia, datalabelsProduccion, getTitle } from '../../../utils/KPIs/productionUtils';
import { Button } from 'primereact/button';
import { getProduccionDiaria } from '../../../API/Produccion/KPIs/KPIs';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { borderColorSintetico } from '../../../Styles/Colors';

const MetasDiariasDialog = ({ semana, setSemana, date, getDatos, IdCategoria }) => {


  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState([]);
  const [chart, setChart] = useState({
    data: {},
    options: {}
  });
  const [chartCotton, setChartCotton] = useState({
    data: {},
    options: {}
  });

  const colorTitle = getTitle(config);

  const getInfo = async () => {
    setLoading(true);
    const produccionDiariaTempo = await getProduccionDiaria({ year: date.getFullYear(), semana });
    setInfo(produccionDiariaTempo)
    const data = [...produccionDiariaTempo]

    const dias = data.map(item => item.NombreDia);

    let AmountTCotton = []
    let AmountTSynthetic = []
    let ProduccionTot = []
    let ProyeccionTot = []
    let proyeccionCotton = []
    let proyeccionSintetico = []
    let realCotton = []
    let realSintetico = []

    console.log(produccionDiariaTempo)

    produccionDiariaTempo.forEach((item) => {
      proyeccionCotton.push(item?.Proyeccion_KgsAlgodon);
      proyeccionSintetico.push(item.Proyeccion_KgsSynthetic);
      realCotton.push(item.KgsTic)
      realSintetico.push(item.KgsTis)
      // ProduccionTot.push(item.KgsTis + item.KgsTic);
      // ProyeccionTot.push(item.TotalProyeccion);

      AmountTCotton.push(item.KgsTic);
      AmountTSynthetic.push(item.KgsTis);
      ProyeccionTot.push(item.TotalProyeccion);
      ProduccionTot.push(item.KgsTis + item.KgsTic + item?.KgsTiRC + item?.KgsTiRS);
    });

    let Mes = date.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);
    setChartCotton({
      data: {
        labels: dias,
        datasets: [
          {
            type: "line",
            label: "Target",
            backgroundColor: colorCotton,
            borderColor: colorCotton,
            data: proyeccionCotton,
            borderDash: [5, 5],
          },

          {
            type: "bar",
            label: "Real",
            backgroundColor: colorCotton,
            borderColor: colorCotton,
            data: realCotton,
          },
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: "index",
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: `${getLabel(baseLang, "pDiariaTitleCotton", config.language)} ` + semana + '   -   ' + monthName + ' / ' + date.getFullYear(),
            color: colorTitle,
            padding: {
              top: 10,
              bottom: 40,
            },
          },
          datalabels: datalabelsProduccion,
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4,
            },
          },
          legend: {
            position: "bottom",
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              minRotation: 0,
              maxRotation: 0,
              color: colorTitle,
              font: {
                size: 10.5,
              },
            },
          },
          y: {
            ticks: {
              color: colorTitle,
              callback: (val, index) => {
                return val > 0
                  ? formatNumber(val).replace(".00", "") + ' Kg'
                  : "";
              },
            },
          },
        },
      },
    });
    setChart({
      data: {
        labels: dias,
        datasets: [
          {
            type: "line",
            label: "Target",
            backgroundColor: borderColorSintetico,
            borderColor: borderColorSintetico,
            data: proyeccionSintetico,
            borderDash: [5, 5],
          },

          {
            type: "bar",
            label: "Real",
            data: realSintetico,
            backgroundColor: colorSintetico,
            borderColor: colorSintetico,
          },
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: "index",
        },
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          title: {
            display: true,
            text: `${getLabel(baseLang, "pDiariaTitleSynthetic", config.language)} ` + semana + '   -   ' + monthName + ' / ' + date.getFullYear(),
            color: colorTitle,
            padding: {
              top: 10,
              bottom: 40,
            },
          },
          datalabels: datalabelsProduccion,
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4,
            },
          },
          legend: {
            position: "bottom",
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              minRotation: 0,
              maxRotation: 0,
              color: colorTitle,
              font: {
                size: 10.5,
              },
            },
          },
          y: {
            ticks: {
              color: colorTitle,
              callback: (val, index) => {
                return val > 0
                  ? formatNumber(val).replace(".00", "") + ' Kg'
                  : "";
              },
            },
          },
        },
      },
    });

    // setChart({
    //   data: {
    //     labels: dias,
    //     datasets: [
    //       {
    //         type: "line",
    //         label: "Target",
    //         backgroundColor: colorCotton,
    //         borderColor: colorCotton,
    //         data: ProyeccionTot,
    //         borderDash: [5, 5],
    //       },

    //       {
    //         type: "bar",
    //         label: "Real",
    //         backgroundColor: colorSintetico,
    //         borderColor: colorSintetico,
    //         data: ProduccionTot,
    //       },
    //     ],
    //   },
    //   options: {
    //     interaction: {
    //       intersect: false,
    //       mode: "index",
    //     },
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     plugins: {
    //       title: {
    //         display: true,
    //         text: `${getLabel(baseLang, "pDiariaTitle", config.language)}` + semana + '   -   ' + monthName + ' / ' + date.getFullYear(),
    //         color: colorTitle,
    //         padding: {
    //           top: 10,
    //           bottom: 40,
    //         },
    //       },
    //       datalabels: datalabelsProduccion,
    //       aspectRatio: 5 / 3,
    //       elements: {
    //         line: {
    //           fill: false,
    //           tension: 0.4,
    //         },
    //       },
    //       legend: {
    //         position: "bottom",
    //         labels: {
    //           color: colorTitle,
    //           font: {
    //             size: 11,
    //           },
    //         },
    //       },
    //     },
    //     scales: {
    //       x: {
    //         stacked: true,
    //         ticks: {
    //           minRotation: 0,
    //           maxRotation: 0,
    //           color: colorTitle,
    //           font: {
    //             size: 10.5,
    //           },
    //         },
    //       },
    //       y: {
    //         ticks: {
    //           color: colorTitle,
    //           callback: (val, index) => {
    //             return val > 0
    //               ? formatNumber(val).replace(".00", "") + ' Kg'
    //               : "";
    //           },
    //         },
    //       },
    //     },
    //   },
    // });

    setLoading(false);

  }


  const columns1 = [
    {
      // Customer
      field: "NombreDia",
      header: "Día",
      headerEn: "Day",
      className: "medium",
      Sumary: "count",
      frozen: "frozen",
      alignFrozen: "left",
    },
    {
      headerName: "Reprocesos",
      children: [
        {
          // Rollos
          field: "KgsTiRC",
          header: "Algodón",
          headerEn: "Cotton",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [1, 3].includes(IdCategoria)
        },
        {
          // Rollos
          field: "KgsTiRS",
          header: "Sintético",
          headerEn: "Synthetic",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [2, 3].includes(IdCategoria)
        },
        {
          // Rollos
          field: "KgsTir",
          header: "Total",
          headerEn: "Total",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [3].includes(IdCategoria)
        },
      ],
    },

    {
      field: "KgsLavado",
      header: "Washing (Kgs)",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      headerName: "Proyección",
      headerNameEn: "Projection",
      children: [
        {
          // Rollos
          field: "Proyeccion_KgsAlgodon",
          header: "Algodón",
          headerEn: "Cotton",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [1, 3].includes(IdCategoria)
        },
        {
          // Rollos
          field: "Proyeccion_KgsSynthetic",
          header: "Sintético",
          headerEn: "Synthetic",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [2, 3].includes(IdCategoria)
        },
      ],
    },
    {
      headerName: "Real",
      children: [
        {
          // Rollos
          field: "KgsTic",
          header: "Algodón",
          headerEn: "Cotton",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [1, 3].includes(IdCategoria)
        },
        {
          // Rollos
          field: "KgsTis",
          headerEn: "Synthetic",
          header: "Sintético",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: [2, 3].includes(IdCategoria)
        },
      ],
    },
    {
      headerName: "TOTALES",
      children: [
        {
          field: "TotalProyeccion",
          headerEn: "Total Projection",
          header: "Proyección Total",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          frozen: true,
          alignFrozen: "right",
          hidden: [3].includes(IdCategoria)
        },
        {
          field: "KgsTotalTR",
          header: "Producción Total",
          headerEn: "Total Production",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          frozen: true,
          alignFrozen: "right",
           hidden: [3].includes(IdCategoria)
        },
      ],
    },
  ];

  const tableT = {
    Data: info,
    Columns: columns1
  };

  useEffect(() => {
    getInfo();
  }, [date])

  useEffect(() => {
    if (getDatos) {
      getInfo()
    }
  }, [getDatos])

  return (
    <div className='produccionMensual'>
      <Loader loading={loading} querySelector={'#metasDiarias'} />
      <Card
        titulo={
          <div className='d-flex'>
            <h4>{getLabel(baseLang, "pDiaria", config.language)}</h4>
          </div>
        }
        contenido={
          <div className='d-flex gap'>
            {[1, 3].includes(IdCategoria) &&
              <div className='col-12' style={{ flex: 1 }}>
                <Chart height={'380px'} width='100%' type='bar' data={chartCotton.data} options={chartCotton.options} plugins={[ChartDataLabels]} />
              </div>
            }
            {[2, 3].includes(IdCategoria) &&

              <div className='col-12' style={{ flex: 1 }}>
                <Chart height={'380px'} width='100%' type='bar' data={chart.data} options={chart.options} plugins={[ChartDataLabels]} />
              </div>
            }
          </div>
        } />

      <div className='mt-2' style={{ width: '100%', height: '300px' }}>
        <AgGrid table={tableT} />
      </div>
    </div>
  );
};

export default MetasDiariasDialog;
